import type { InsightSummary } from '@/apis/insights';
import { INTENT_TYPES, REQUEST_CONTEXT_BUTTON_IDENTIFIERS } from '@/components/VisionAi/constants';
import { useRecordInsightInteraction } from '@/shared/queries/use-record-insight-interaction';
import { useVisionAiStore } from '@/stores/vision-ai';

export function useViewInsight() {
  const visionAiStore = useVisionAiStore();
  const { recordInteraction } = useRecordInsightInteraction();

  async function viewInsight(insight: InsightSummary) {
    recordInteraction({
      insightId: insight.id,
      interactionType: 'actioned',
    });
    visionAiStore.openChatWindow();
    visionAiStore.startNewChat();
    await visionAiStore.startConversation({
      message: 'View Insight',
      intentTypeOverride: INTENT_TYPES.UNIFIED,
      buttonIdentifier: REQUEST_CONTEXT_BUTTON_IDENTIFIERS.VIEW_INSIGHT,
      extra: { insightId: insight.id },
      filters: {},
    });
  }

  return { viewInsight };
}
